<template>
  <div :class="computedClass">
    <router-view />
    <portal-target name="modal" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { isPostTransactionScreen } from '@/utils'

export default {
  name: 'App',
  computed: {
    ...mapState('transaction', ['hideContent', 'showBodyOnly', 'transaction']),
    computedClass() {
      return {
        hide: this.hideContent,
        app: !this.hideContent,
        'iframe-container':
          !this.hideContent &&
          this.showBodyOnly &&
          !isPostTransactionScreen(this.$route.name),
        'pf-post-trans':
          this.showBodyOnly && isPostTransactionScreen(this.$route.name),
        'pf-tnx': this.transaction.theme === 'PF',
      }
    },
  },
}
</script>

<style lang="scss">
.app {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;

  @media screen and (max-width: $mobile-resolution) {
    position: relative;
    width: 100%;
    display: block;
    padding: 0;
  }
}

.iframe-container {
  padding: 0;
  height: 100%;
  align-items: unset;
}

.pf-post-trans {
  height: 100%;
  width: 100%;
  background: #fff;
  padding: 0;
}

.hide {
  display: none;
}
</style>
